import SelfAssignError from './SelfAssignError';

export default SelfAssignError;
